// extracted by mini-css-extract-plugin
export default {"container":"TeamsFilter_container__-ntxZ","avatar":"TeamsFilter_avatar__rbolF"};